import React, { ChangeEvent, useEffect, useState } from "react";
import LoacationMaps from "../TitleAndDesc/location-map";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { getPropertiesById, PublishPropertiesServ, RefreshProccesing, UpdatePropertyService } from "../../../Services/Properties";
import ListImageGallery from "./list-image-gallery";
import ContactAgent from "./contact-agent";
import Card from "./Card";
import { useNavigate } from "react-router-dom";
import Amenities from "../../property-details/amenities";
import EditListing from "../../edit-listing/edit-listing";
import { PropertyDetailsObj } from "../../../Models/PropertyDetailsObj";
import DownoaldXmlPdf from "./download-xml-pdf";
import PropertyInformation from "../../property-details/property-information";
import DescriptionDetails from "../../property-details/description-details";
import CountryDetails from "../../property-details/country-details";
import DescriptionWithReadMore from "../../property-details/desc-with-read-more";
import { useTranslation } from "react-i18next";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const MarketingAssests: React.FunctionComponent<{ onChangeTaps: any, onChangehandler: any }> = (props) => {

    const [portalStates, setPortalStates] = useState([
        { name: "Property Finder", value: "Propertyfinder", logo: "/assets/images/icons/logo-1.png", enabled: false },
        { name: "Bayut", value: "Bayut", logo: "/assets/images/icons/logo-2.png", enabled: false },
        { name: "Coraly", value: "Coraly", logo: "/assets/images/icons/logo-trans.png", enabled: true },
    ]);
    const [property, setProperty] = useState<PropertyDetailsObj>({});
    const [popupPublish, setPopupPublish] = useState<boolean>(false);
    const [publicLink] = useState(`${process.env.REACT_APP_CLIENT_URL}/property/${sessionStorage.getItem('propertyId')}`);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const navigate = useNavigate();
    const [selectedLang, setSelectedLang] = useState("");
    const [loading, setLoading] = useState(true);
    const [isChange, setIsChange] = useState<boolean>(false);
    const [processImages, setProcessImages] = useState<any>(() => {
        const storedData = sessionStorage.getItem("stastics");
        return storedData ? JSON.parse(storedData) : null;
    });
    const [isRefresh, setISRefresh] = useState<boolean>(false);
    const [copied, setCopied] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
        const id: any = sessionStorage.getItem('propertyId');
        getPropertiesById(id).then((data) => {
            setProperty(data)
            setLoading(false);
            setSelectedLang(data.content.languages[0])
        }).catch((error) => {
            console.log(error)
        })
    }, [isChange])

    const togglePortal = (index: number) => {
        const updatedPortals = [...portalStates];
        updatedPortals[index].enabled = !updatedPortals[index].enabled;
        setPortalStates(updatedPortals);
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(publicLink)
            .then(() => {
                setCopied(true);
                setTimeout(() => {
                    setCopied(false);
                }, 3000);
            });
    };

    const handleCloseDialog = () => {
        setPopupPublish(false)
    }

    const capitalizeFirstLetter = (word: any) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }


    const PublishProperty = () => {
        const activePortals = portalStates
            .filter(portal => portal.enabled)
            .map(portal => portal.value);
        const listings = {
            "properties": [sessionStorage.getItem('propertyId')],
            "portals": activePortals,
            "publish": true
        }
        setPopupPublish(false);
        PublishPropertiesServ(listings).then((data: any) => {
            sessionStorage.removeItem("listing");
            sessionStorage.removeItem("property_details");
            sessionStorage.removeItem("processid");
            sessionStorage.removeItem("propertyId");
            sessionStorage.removeItem("taps");
            props.onChangehandler("Your listing has been published successfully", true, "success")
            setTimeout(() => {
                navigate("/properties")
            }, 5000)
        }).catch((error: any) => {
            props.onChangehandler("Failed to publish the listing.", true, "error")

        })
    }

    const UpdatePropertyHandler = (property: any, id: any) => {
        UpdatePropertyService(property, id).then((data) => {
            props.onChangehandler("Listing Updated Successfully !", true, "success")
            setIsChange(!isChange)
        }).catch((error: any) => {
            props.onChangehandler("Failed to update Listing.", true, "error")
        })

    }

    const handleDownload = (msg: any, error: boolean, color: string) => {
        props.onChangehandler(msg, error, color)
    }

    const HandleCloseCreation = () => {
        sessionStorage.removeItem("listing");
        sessionStorage.removeItem("property_details");
        sessionStorage.removeItem("processid");
        sessionStorage.removeItem("propertyId");
        sessionStorage.removeItem("taps");
        navigate("/properties")
    }

    const HandleRefreshProccesing = () => {
        setISRefresh(true)
        RefreshProccesing(sessionStorage.getItem("processid")).then((data) => {
            setISRefresh(false);
            setProcessImages(data);
            sessionStorage.setItem("stastics", JSON.stringify(data));
        }).catch((error) => {
            console.log(error)
        })
    }

    const getDescriptionByLang = (lang: string) => {
        const descList = property?.content?.description;
        if (!Array.isArray(descList)) return "";
        const found = descList.find((item) => item.lang === lang);
        return found ? found.desc : "";
    }

    const getTitleByLang = (lang: string) => {
        const titleList = property?.content?.title;
        if (!Array.isArray(titleList)) return "";
        const found = titleList.find((item) => item.lang === lang);
        return found ? found.title : "";
    }

    return loading ? (<> Loading ...</>) : (
        <>
            <div className="row d-flex align-items-center mb-4">
                <div className="col-md-3">
                </div>
                <div className="col-md-6 mb-4 justify-content-center">
                    <div className=" text-center">
                        <h1 className="title-24 mb-3">{t("listingCreation.yourListingReady")} <span className="color-64748B title-18 bold-600">({t("propertiesPage.id")}: {property?.id})</span></h1>
                        <p className="para-16 color-39393B">{t("listingCreation.titlePublish")}</p>
                    </div>
                </div>
                <div className="col-md-3 mb-4 d-flex-end">

                    <DownoaldXmlPdf onChangehandler={handleDownload} />

                    <button className="button-reset border-746AFF color-746AFF back-trans padd-15 marg-right-16" onClick={HandleCloseCreation}>
                        {t("propertiesPage.close")}
                    </button>
                </div>
            </div>
            
            <div className="row">
                <div className="col-md-12">
                    <div className="mt-4 mb-3 d-flex justify-content-between align-items-center">
                        <div className="d-flex">
                            <h1 className="title-24 para-16-mb marg-right-16">{t("listingCreation.listingPreview")} </h1>
                            <div className="dropdown">
                                <button
                                    className="btn dropdown-toggle para-14 color-black bold-500"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <img src="/assets/images/icons/language-svgrepo-com.svg" width="21" className="marg-right-10" alt="lang" />
                                    {selectedLang.charAt(0).toUpperCase() + selectedLang.slice(1)}
                                    <svg width="14" height="15" viewBox="0 0 14 15" className="marg-left-5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_519_427)">
                                            <path d="M3.5 5.75L7 9.25L10.5 5.75" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_519_427">
                                                <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                                            </clipPath>
                                        </defs>
                                    </svg>

                                </button>

                                <ul className="dropdown-menu text-center" aria-labelledby="dropdownMenuButton">
                                    {property?.content?.languages && property?.content?.languages.map((language: any) => (
                                        <li key={language}>
                                            <button
                                                className="dropdown-item text-center"
                                                onClick={() => setSelectedLang(language)}
                                            >
                                                {language.charAt(0).toUpperCase() + language.slice(1)}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <EditListing property={property ?? {}} onUpdateProperty={UpdatePropertyHandler} />
                    </div>
                    <div className="sliderProp">
                        <ListImageGallery images={property?.content?.images} />
                    </div>

                    <div className="row">
                        <div className="col-8 mb-1">
                            <h3 className="title-20 title-18-mb color-black line-height-30">{getTitleByLang(selectedLang)}</h3>
                        </div>
                        <div className="col-4 mb-1">
                            <h3 className="title-20 color-746AFF bold-800 text-end">{Number(property?.content?.price?.amount).toLocaleString("en-US")}  {property?.content?.price?.currency}</h3>
                        </div>
                    </div>

                    <PropertyInformation property={property} />

                    <Amenities private_amenities={property?.content?.private_amenities} shared_amenities={property?.content?.shared_amenities} />

                    <h3 className="title-20  mb-4 color-black line-height-30"> {t("generateDescTitle.description")}</h3>

                    <DescriptionDetails property={property} />

                    <DescriptionWithReadMore text={getDescriptionByLang(selectedLang)} />

                    <CountryDetails property={property} />

                    {property?.content?.videoTourUrl && <>    <h3 className="title-20 mt-4 mb-4 color-black line-height-30">3D Tour</h3>

                        <div className="row">
                            <div className="col-md-8 mb-3">
                                <iframe
                                    src={property?.content?.view360} frameBorder="0"
                                    allowFullScreen
                                    className="embed-responsive-item"
                                />
                            </div>
                        </div>
                    </>}
                    {property?.content?.videoTourUrl && <><h3 className="title-20  mt-4 mb-4 color-black line-height-30">Video</h3>

                        <div className="row">
                            <div className="col-md-8 mb-3">
                                <video
                                    src={property?.content?.videoTourUrl}
                                    controls
                                    className="embed-responsive-item"
                                />
                            </div>
                        </div>
                    </>}
                    <div className="row mt-4 mb-4">
                        <div className="col-md-7">
                            <div className="card-form padd-20">
                                <h3 className="title-20 mb-4 color-black line-height-30 ">{t("propertiesPage.location")} </h3>
                                <LoacationMaps position={[property?.content?.address?.latitude, property?.content?.address?.longitude]} zoomValue={13} address={property?.content?.address} height={270} />
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="card-form padd-15">
                                <h3 className="title-20 color-black  mb-4 line-height-30 "> {t("listingCreation.agentDetails")} </h3>
                                <ContactAgent agent={property?.content?.agent} />
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end mt-4">
                        <button type="submit" className="button-dash back-EEF2FF mb-3 z-index-1 color-4F52C1 border-4F52C1 border-6 padd-15-30 width-auto bold-700 marg-right-16"
                            onClick={() => setPopupPublish(true)}
                        >
                            {t("propertiesPage.publish")}
                        </button>
                    </div>
                </div>
            </div >

            <BootstrapDialog
                open={popupPublish}
                onClose={handleCloseDialog}
                aria-labelledby="customized-dialog-title"
                fullWidth={true}
                maxWidth="sm"
            >
                <DialogTitle >
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDialog}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[800],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <div className="">
                        <div className="modal-header">
                            <h2>{t("listingCreation.portals")}</h2>
                            <a href="#">{t("listingCreation.addnewPortal")}</a>
                        </div>

                        <p className="mt-4 mb-4 para-16 color-black">
                            {t("listingCreation.selectPotalsPublish")}
                        </p>
                        {portalStates.map((portal, index) => (
                            <div key={index} className="portal-item">
                                <div className="portal-info">
                                    <img src={portal.logo} alt={portal.name} />
                                    <span className="portal-name">{portal.name}</span>
                                </div>
                                <div
                                    className={`toggle-switch ${portal.enabled ? "active" : ""}`}
                                    onClick={() => togglePortal(index)}
                                ></div>
                            </div>
                        ))}

                        <div className="public-link">
                            <p>{t("listingCreation.shareLink")}</p>
                            <div className="link-container">
                                <input type="text" value={publicLink} readOnly />
                                <button className={`button-dash back-trans padd-10 ${copied ? "color-16A34A border-16A34A" : "border-746AFF color-746AFF"}`}
                                    onClick={handleCopy}>  {copied ? `${t("listingCreation.copied")}` : `${t("listingCreation.copy")}`}</button>
                            </div>
                        </div>

                        <button className="button-dash back-746AFF color-FFFFFF  mt-4 border-746AFF padd-15-30 width-auto " onClick={PublishProperty}>{t("propertiesPage.publish")}</button>
                    </div>
                </DialogContent>
            </BootstrapDialog>
        </>
    )
}

export default MarketingAssests;